import type { TFunction } from 'i18next';
import { flow } from 'lodash-es';
import type { ReactElement, ReactNode } from 'react';

import logoIcon from 'img/logos/logo.svg';

import withTranslate from 'common/i18n/i18n';

import ChangeAppLanguage from '../change_language';

import './authLayout.page.scss';

interface AuthLayoutProps {
    t: TFunction;
    children: ReactNode;
}
/* eslint-disable react-refresh/only-export-components */
const AuthLayout = ({ t, children }: AuthLayoutProps): ReactElement => {
    return (
        <div id="auth_layout">
            <div id="auth_layout_page" className="page">
                <div className="main-content">
                    <div className="logo">
                        <img alt={t('login.clinical_logo_alt')} src={logoIcon} />
                    </div>
                    <div id="auth_layout_box">
                        <div className="auth-layout-box">
                            <div className="auth-layout-box-content" role="main">
                                {children}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ChangeAppLanguage />
        </div>
    );
};

const WrappedAuthLayout = flow([withTranslate('auth')])(AuthLayout);

export const withAuthLayout = (WrappedComponent) => {
    return (props): ReactElement => {
        return (
            <div>
                <WrappedAuthLayout>
                    <WrappedComponent {...props} />
                </WrappedAuthLayout>
            </div>
        );
    };
};
